import moment from 'moment';
import { ScriptService } from '../../../controllers/ScriptService';
import { StreamType } from '../../../interfaces';
import { PlayData } from '../../../queries/ats/playback/api';
import { SingleRecording } from '../../../queries/ats/recordings/types/recording';

export function getRecordingStream(recording: SingleRecording, data: PlayData, position: number) {
  let licenseUrl = '';
  if (ScriptService._isSafari()) {
    licenseUrl = data.licenseUrl ? data.licenseUrl : '';
  }

  const startTime = moment(recording.startTime).subtract(recording.startOffset, 'minutes');
  const endTime = moment(recording.endTime).add(recording.endOffset, 'minutes');

  return {
    title: recording.name,
    picture: {
      deflate: recording.image,
      href: recording.image,
      poster: recording.image,
      still: recording.image,
      other: recording.image,
      ad: recording.image,
      background: recording.image,
    },
    isGuest: false,
    streamType: StreamType.PVR,
    programStart: startTime.format(),
    programEnd: endTime.format(),
    mediaId: recording.mediaId,
    contentId: recording.channelId,
    pvrId: recording.id,
    startBookmark: position,
    playData: {
      manifestUrl: data.url,
      licenseUrl: licenseUrl,
      customData: data.token,
      currentTime: position,
    },
  };
}
